import { render } from "./TextButton.vue?vue&type=template&id=98211772"
import script from "./TextButton.vue?vue&type=script&lang=ts"
export * from "./TextButton.vue?vue&type=script&lang=ts"
script.render = render

export default script